import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { ConfigResolve } from './shared/services/config.resolve';
import { HttpClientModule } from '@angular/common/http';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { CategoriesComponent } from './categories/categories.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { AngularFittextModule } from 'angular-fittext';
import { TaskComponent } from './task/task.component';
import { TaskWordComponent } from './task/task-word/task-word.component';
import { TaskMemoryComponent } from './task/task-memory/task-memory.component';
import { TaskPuzzleComponent } from './task/task-puzzle/task-puzzle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { TaskPuzzleModule } from './task/task-puzzle/task-puzzle.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SaveWordComponent } from './shared/components/save-word/save-word.component';
import { ZrobtosamComponent } from './zrobtosam/zrobtosam.component';
import { PageCzujkiComponent } from './page-czujki/page-czujki.component';
import { PageDomusieComponent } from './page-domusie/page-domusie.component';
import { PageNiebyleczoComponent } from './page-niebyleczo/page-niebyleczo.component';
import { RandomizeComponent } from './shared/randomize/randomize.component';
// import { BabekComponent } from './relacjeiuczucia/babek/babek.component';
// import { RelacjeComponent } from './relacjeiuczucia/relacje/relacje.component';
// import { UczuciaComponent } from './relacjeiuczucia/uczucia/uczucia.component';

@NgModule({
  declarations: [
    AppComponent,    
    PageNotFoundComponent,
    CategoriesComponent,
    HeaderComponent,
    FooterComponent,
    TaskComponent,
    TaskWordComponent,
    TaskMemoryComponent,
    TaskPuzzleComponent,
    SaveWordComponent,
    ZrobtosamComponent,
    PageCzujkiComponent,
    PageDomusieComponent,
    PageNiebyleczoComponent,
    RandomizeComponent,
    // BabekComponent,
    // RelacjeComponent,
    // UczuciaComponent    
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    HomeModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFittextModule,
    BrowserAnimationsModule,
    // TaskPuzzleModule,
    DragDropModule
  ],
  providers: [
    ConfigResolve
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
